import React from "react";
import { useNavigate } from "react-router-dom";
import { Crown } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { navigateToPremiumPurchase } from "../utils/subscriptionQrFlow";
import { Button } from "./ui/button";
import { PremiumLinkedText } from "./premium/PremiumFeatures";

const PremiumExpiryBadge = ({ subscription, className = "", qrId = "" }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  if (!subscription?.endDate) return null;

  const end = new Date(subscription.endDate);
  const days = subscription.daysRemaining ?? 0;
  const formatted = end.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
  const urgent = days <= 30;
  const showRenew = Boolean(qrId) && urgent;

  return (
    <div
      className={`flex flex-wrap items-center gap-2 rounded-lg border px-3 py-2 text-sm ${
        urgent ? "border-amber-300 bg-amber-50 text-amber-900" : "border-violet-200 bg-violet-50 text-violet-900"
      } ${className}`}
    >
      <Crown size={16} className="shrink-0" aria-hidden />
      <span className="min-w-0">
        <PremiumLinkedText
          text={
            days > 0
              ? t("premium.expiresLine")
                  .replace("{{days}}", String(days))
                  .replace("{{date}}", formatted)
              : t("premium.expiresOn").replace("{{date}}", formatted)
          }
        />
      </span>
      {showRenew && (
        <Button
          type="button"
          size="sm"
          className="ml-auto shrink-0"
          onClick={() => navigateToPremiumPurchase(navigate, { qrId, variant: "renew" })}
        >
          {t("premium.renewMembership")}
        </Button>
      )}
    </div>
  );
};

export default PremiumExpiryBadge;
